import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class SetSmartbannerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({repository, log}) {
    super({
      repository,
      log
    })

    this._repository = repository
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>} returns smartbanner func
   * @property {Object} setCookie
   */
  async execute() {
    return this._repository.setSmartbanner()
  }
}
